export const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)];
